define('OutSystems/ClientRuntime/NativeLogger',["require", "exports", "tslib", "./Logger"], function (require, exports, tslib_1, Logger) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.sendOTLog = exports.sendLog = exports.postLog = exports.NetworkStatus = void 0;
    var NetworkStatusModule;
    (function (NetworkStatusModule) {
        function isOnline() {
            return !!getNativeLogger();
        }
        NetworkStatusModule.isOnline = isOnline;
        function onOnline(_) { }
        NetworkStatusModule.onOnline = onOnline;
        function onOffline(_) { }
        NetworkStatusModule.onOffline = onOffline;
        function ping() {
            if (isOnline()) {
                return Promise.resolve();
            }
            else {
                return Promise.reject(new Error("NativeLogger API is not available"));
            }
        }
        NetworkStatusModule.ping = ping;
    })(NetworkStatusModule || (NetworkStatusModule = {}));
    exports.NetworkStatus = NetworkStatusModule;
    function getNativeLogger() {
        var _a;
        var w = window;
        return (_a = w === null || w === void 0 ? void 0 : w.OutSystemsNative) === null || _a === void 0 ? void 0 : _a.Logger;
    }
    function getNativeOTLogger() {
        var _a;
        var w = window;
        return (_a = w === null || w === void 0 ? void 0 : w.OutSystemsNative) === null || _a === void 0 ? void 0 : _a.OTLogger;
    }
    function postLog(logMessages) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var logger, otLogger, _i, logMessages_1, message;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logger = getNativeLogger();
                        otLogger = getNativeOTLogger();
                        if (!((otLogger || logger) && (logMessages === null || logMessages === void 0 ? void 0 : logMessages.length) > 0)) return [3, 6];
                        _i = 0, logMessages_1 = logMessages;
                        _a.label = 1;
                    case 1:
                        if (!(_i < logMessages_1.length)) return [3, 6];
                        message = logMessages_1[_i];
                        if (!otLogger) return [3, 3];
                        return [4, exports.sendOTLog(otLogger, message)];
                    case 2:
                        _a.sent();
                        return [3, 5];
                    case 3: return [4, exports.sendLog(logger, message)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        _i++;
                        return [3, 1];
                    case 6: return [2];
                }
            });
        });
    }
    exports.postLog = postLog;
    var sendLog = function (logger, message) {
        return new Promise(function (resolve, reject) {
            switch (message.logType) {
                case Logger.LogTypes.General:
                    logger.logInfo(message.message, message.moduleName, resolve, reject);
                    break;
                case Logger.LogTypes.Error:
                    logger.logError(message.message, message.moduleName, message.extra, message.stack, resolve, reject);
                    break;
                case Logger.LogTypes.Trace:
                    logger.logDebug(message.message, message.moduleName, resolve, reject);
                    break;
                default:
                    logger.logError("Unknown log type: " + message.logType + "; Message: " + message.message, "NativeLogger", message.extra, new Error().stack, resolve, reject);
            }
        });
    };
    exports.sendLog = sendLog;
    var sendOTLog = function (logger, message) {
        switch (message.logType) {
            case Logger.LogTypes.General:
                return logger.logInfo({
                    instant: message.instant,
                    message: message.message,
                    source: message.moduleName,
                });
            case Logger.LogTypes.Error:
                return logger.logError({
                    instant: message.instant,
                    message: message.message,
                    source: message.moduleName,
                    attributes: message.extra,
                    stack: message.stack,
                });
            case Logger.LogTypes.Trace:
                return logger.logDebug({
                    instant: message.instant,
                    message: message.message,
                    source: message.moduleName,
                });
            default:
                return logger.logError({
                    instant: new Date().toISOString(),
                    message: "Unknown log type: " + message.logType + "; Message: " + message.message,
                    source: "NativeLogger",
                    attributes: message.extra,
                    stack: new Error().stack,
                });
        }
    };
    exports.sendOTLog = sendOTLog;
});
//# sourceMappingURL=NativeLogger.js.map;
